import React, { useMemo, useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {
    getPriceRequest,
    getRaisedDataByID,
    getGroups,
    getNotConfirmed,
    getNotExecuted,
} from 'redux/datasource/dataSourceSlice';
import {
    getAllPriceRequests,
    getNoConfirmedData,
    getNoExecutedData,
    getPriceReqRaisedDataByID,
} from 'redux/datasource/dataSourceActions';
import { useSelector } from 'react-redux';
import { useCommonInits } from 'hooks/useCommonInits';
import { getUser, getUnitIds } from 'redux/auth/authSlice';
import { Grid, Typography, Paper } from '@mui/material';
import RequestPageIcon from '@mui/icons-material/RequestPage';

export const NotConfirmed = () => {
    const user = useSelector(getUser);
    const { dispatch } = useCommonInits();
    const [pageSize, setPageSize] = useState(10);
    const notConfirmed = useSelector(getNotConfirmed);
    const notExecuted = useSelector(getNotExecuted);
    const getGroup = useSelector(getGroups);
    const units = useSelector(getUnitIds);
    const unitIds = JSON.parse(units);
    const filteredGroups = getGroup?.filter(val => {
        return unitIds.find(a => {
            return val.name === a;
        });
    });

    useEffect(() => {
        dispatch(getAllPriceRequests());
    }, []);

    useEffect(() => {
        if (getGroup) {
            const params = {
                group_id: filteredGroups.map(group => group._id),
            };
            dispatch(getPriceReqRaisedDataByID(params));
            dispatch(getNoConfirmedData(params));
            dispatch(getNoExecutedData(params));
        }
    }, [getGroup]);

    const columns = useMemo(
        () => [
            {
                field: 'date_time',
                headerName: 'Date Time For Execution',
                width: 350,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'group_name',
                headerName: 'Group Name',
                width: 250,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'price_request_name',
                headerName: 'Price Request Name',
                width: 250,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'old_price',
                headerName: 'Old Price',
                width: 200,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'price',
                headerName: 'New Price',
                width: 200,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'confirmed',
                headerName: 'Confirmed',
                width: 150,
                sortable: false,
                filterable: false,
                allowSorting: 'false',
                textAlign: 'left',
            },
        ],
        [],
    );
    return (
        <div>
            <Paper sx={{ margin: 2 }}>
                <div>
                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        sx={{ p: 2 }}
                    >
                        <Grid item>
                            <RequestPageIcon fontSize="large" />
                        </Grid>
                        <Grid item sx={{ pl: 1 }}>
                            <Typography variant="h5">
                                Pending Price Requests
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            </Paper>
            <Paper sx={{ margin: 2 }}>
                <DataGrid
                    disableColumnMenu
                    rows={
                        user.app_type.includes('APCM_Authorizer')
                            ? notConfirmed
                            : notExecuted
                    }
                    columns={columns}
                    getRowId={row => row._id}
                    rowsPerPageOptions={[10, 25, 50]}
                    autoHeight={true}
                    pageSize={pageSize}
                    onPageSizeChange={newPage => setPageSize(newPage)}
                    getRowSpacing={params => ({
                        top: params.isFirstVisible ? 0 : -2,
                        bottom: params.isLastVisible ? 0 : -2,
                    })}
                />
            </Paper>
        </div>
    );
};
